import runloop from '../../../../global/runloop';
import Element from '../../Element';

var Form = (function (Element) {
	function Form ( options ) {
		Element.call( this, options );
		this.formBindings = [];
	}

	if ( Element ) Form.__proto__ = Element;
	Form.prototype = Object.create( Element && Element.prototype );
	Form.prototype.constructor = Form;

	Form.prototype.render = function render ( target, occupants ) {
		Element.prototype.render.call( this, target, occupants );
		this.node.addEventListener( 'reset', handleReset, false );
	};

	Form.prototype.unrender = function unrender ( shouldDestroy ) {
		this.node.removeEventListener( 'reset', handleReset, false );
		Element.prototype.unrender.call( this, shouldDestroy );
	};

	return Form;
}(Element));

export default Form;

function handleReset () {
	var element = this._ractive.proxy;

	runloop.start();
	element.formBindings.forEach( updateModel );
	runloop.end();
}

function updateModel ( binding ) {
	binding.model.set( binding.resetValue );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/element/specials/Form.js.map
